import { render, staticRenderFns } from "./FormArea.vue?vue&type=template&id=25256241"
import script from "./FormArea.vue?vue&type=script&lang=js"
export * from "./FormArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25256241')) {
      api.createRecord('25256241', component.options)
    } else {
      api.reload('25256241', component.options)
    }
    module.hot.accept("./FormArea.vue?vue&type=template&id=25256241", function () {
      api.rerender('25256241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormArea.vue"
export default component.exports